import * as React from 'react';
import Landing from '../components/Landing';
import PhotoGallery from '../components/PhotoGallery';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Seo } from '../components/seo.js';

import '../styles/styles.css';

const IndexPage = ({ location }) => {
  return (
    <>
      <Seo />
      <Landing />
      <Header location={location.pathname} />
      <PhotoGallery />
      <Footer />
    </>
  );
};

export default IndexPage;
